<template>
    <div class="open-tendering">
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">项目名称:</label>
                <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" class="search-input" clearable />

                <label class="search-label">招标人名称:</label>
                <el-input v-model="searchForm.tendereeName" placeholder="请输入招标人名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>

                <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
                    添加信息
                </el-button>
            </div>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip />
                <el-table-column prop="agencyProjectManagerName" label="项目经理" align="center" />
                <el-table-column prop="tendereeContactPerson" label="招标人" align="center" />
                <el-table-column prop="status" label="提交状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 1">已提交</span>
                        <span v-else>暂存</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn"
                            v-if="scope.row.status == 1">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn"
                            v-if="scope.row.status !== 1">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewStatus(scope.row)" class="action-btn"
                            v-if="scope.row.status === 1">
                            进入流程
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
        <!-- 项目详情弹窗 -->
        <ProjectDetailDialog :visible.sync="detailDialogVisible" :project-detail="projectDetail"
            @close="handleDetailDialogClose" />
    </div>
</template>

<script>
import { getProjectList, getProjectDetail, deleteProject, enterEvaluation } from '@/api/agent/api'
import ProjectDetailDialog from '@/components/agent/ProjectDetailDialog.vue'


export default {
    name: 'OpenTendering',
    components: {
        ProjectDetailDialog
    },
    data() {
        return {
            loading: false,
            searchForm: {
                projectName: '',
                tendereeName: ''
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 详情弹窗相关
            detailDialogVisible: false,
            projectDetail: null,
        }
    },
    mounted() {
        this.loadData()
        // 获取路由中的type
        this.procurementType = this.$route.query.type

    },
    methods: {
        // 添加信息
        handleAdd() {
            this.$router.push({ name: 'addTender', query: { type: '公开招标新增项目信息', procurementType: this.procurementType } })
        },
        // 加载数据
        loadData() {
            this.loading = true
            let dictData = {
                projectType: '01',
                pageNum: this.pagination.currentPage.toString(),
                pageSize: this.pagination.pageSize.toString(),
                tendereeName: this.searchForm.tendereeName,
                projectName: this.searchForm.projectName,
                procurementType: this.$route.query.type,

            }
            getProjectList(dictData).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                    this.pagination.currentPage = res.data.current || 1
                } else {
                    this.$message.error(res.message || '获取数据失败')
                    this.tableData = []
                    this.pagination.total = 0
                }
                this.loading = false
            }).catch(error => {
                console.error('获取项目列表失败:', error)
                this.$message.error('获取数据失败')
                this.tableData = []
                this.pagination.total = 0
                this.loading = false
            })
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 查看详情
        handleViewDetails(row) {
            this.getProjectDetail(row.projectCode)
        },
        // 获取项目详情
        getProjectDetail(projectCode) {
            getProjectDetail({ projectCode: projectCode }).then(res => {
                if (res.code === 200) {
                    this.projectDetail = res.data
                    this.detailDialogVisible = true

                } else {
                    this.$message.error(res.msg || '获取项目详情失败')
                }
            }).catch(error => {
                console.error('获取项目详情失败:', error)
                this.$message.error('获取项目详情失败')
            })
        },
        //删除项目
        handleDelete(row) {
            this.$confirm('确定要删除该项目吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteProject(row.projectCode)
            }).catch(() => {
            })
        },
        //删除项目
        deleteProject(projectCode) {
            deleteProject(projectCode).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadData()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            }).catch(error => {
                console.error('删除项目失败:', error)
                this.$message.error('删除失败')
            })
        },
        // 弹窗关闭处理
        handleDetailDialogClose() {
            this.projectDetail = null
        },
        // 编辑（暂存状态）
        handleEdit(row) {
            this.$router.push({
                name: 'addTender',
                query: {
                    type: '公开招标新增项目信息',
                    procurementType: this.procurementType,
                    projectCode: row.projectCode,
                    id: row.id
                }
            })
        },
        // 查看状态
        handleViewStatus(row) {
            this.enterEvaluation(row)

        },
        // 进入流程
        enterEvaluation(row) {
            enterEvaluation({ projectCode: row.projectCode }).then(res => {
                if (res.code === 200) {
                    // 根据当前路由判断跳转到哪个查看流程页面
                    const currentPath = this.$route.path
                    let flowRoute = 'politicsProjectFlow' // 默认企业采购
                    if (currentPath.includes('/gov')) {
                        flowRoute = 'govPoliticsProjectFlow' // 政府采购
                    } else if (currentPath.includes('/construction')) {
                        flowRoute = 'constructionPoliticsProjectFlow' // 建设工程
                    }
                    this.$router.push({ name: flowRoute, query: { type: '公开招标项目信息', projectCode: row.projectCode, projectId: row.id, procurementType: this.$route.query.type } })

                } else {
                    this.$message.error(res.msg || '进入流程失败')
                }
            })
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(open-tendering);
</style>
